export function debounce(func, wait) {
  let timeout;
  let pending;

  const debounced = function (...args) {
    const context = this;
    pending = { context, args };

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      pending = null;
      func.apply(context, args);
    }, wait);
  };

  debounced.flush = function () {
    if (!pending) return;
    clearTimeout(timeout);
    const { context, args } = pending;
    pending = null;
    func.apply(context, args);
  };

  return debounced;
}

export function debounceAsync(func, wait) {
  let timeout;
  let promiseInProgress = null;

  return function (...args) {
    const context = this;

    clearTimeout(timeout);

    return new Promise((resolve, reject) => {
      timeout = setTimeout(async () => {
        if (promiseInProgress) {
          await promiseInProgress;
        }

        try {
          promiseInProgress = func.apply(context, args);
          const result = await promiseInProgress;
          resolve(result);
        } catch (error) {
          reject(error);
        } finally {
          promiseInProgress = null;
        }
      }, wait);
    });
  };
}
